import React from 'react';
export const Hero = () => {
  return <section className="relative bg-blue-900 text-white" data-id="element-197">
      <div className="absolute inset-0 bg-black opacity-50" data-id="element-198"></div>
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/rucx2avFRacuoDcqGBJy85/iStock-1094152694.jpg')",
      opacity: 0.6
    }} data-id="element-199"></div>
      <div className="container mx-auto px-4 py-20 md:py-32 relative z-10" data-id="element-200">
        <div className="max-w-2xl" data-id="element-201">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-202">
            Professional Pressure Washing Services
          </h1>
          <p className="text-xl mb-8" data-id="element-203">
            Restore your property's beauty with our expert pressure washing
            services. We clean driveways, decks, siding, and more!
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-204">
            <a href="#contact" className="bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-6 rounded-lg transition-colors text-center" data-id="element-205">
              Get a Free Quote
            </a>
            <a href="#services" className="bg-white hover:bg-gray-100 text-green-900 font-medium py-3 px-6 rounded-lg transition-colors text-center" data-id="element-206">
              Our Services
            </a>
          </div>
        </div>
      </div>
    </section>;
};